export default "__VITE_ASSET__DAursWA5__"